window.addEventListener('load', function () {

    const depChoseSites = [
        {
            hostname: ["omsk.varikozanet.bitru.ru", "varikozanet.bitru.ru"],
            popup: "#dep-choice-omsk"
        },
        {
            hostname: ["nsk.varikozanet.bitru.ru", "nsk2.varikozanet.bitru.ru"],
            popup: "#dep-choice"
        },
        {
            hostname: ["kazan2.varikozanet.bitru.ru", "kazan.varikozanet.bitru.ru"],
            popup: "#dep-choice-kazan"
        },
    ]

    function getCurrentSite(sites) {
        return sites.find(function (item) {
            return item.hostname.find(function (item) {
                return item === window.location.hostname
            })
        })
    }

    function isRefererFromSubdomain() {
        return !document.referrer || document.referrer.includes("varikozanet.bitru.ru")
    }

    function showPopupDepChose() {
        if (isRefererFromSubdomain()) {
            return
        }
        const currentSite = getCurrentSite(depChoseSites)
        if (currentSite) {
            const popupTrigger = document.querySelector('.js-popup-trigger[data-popup="' + currentSite.popup + '"]')
            if (popupTrigger)
                popupTrigger.dispatchEvent(new Event('click', {bubbles: true}))
        }
    }

    showPopupDepChose()
})



